// src/components/Footer.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  const quickLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/team", label: "Team" },
    { path: "/contact", label: "Contact" },
  ];

  const programs = [
    "Prevention Programs",
    "Protection Services",
    "Empowerment Initiatives",
    "Community Coordination",
  ];

  const socialLinks = [
    { icon: "📘", platform: "Facebook", url: "#" },
    { icon: "📸", platform: "Instagram", url: "#" },
    { icon: "🐦", platform: "Twitter", url: "#" },
    { icon: "💼", platform: "LinkedIn", url: "#" },
  ];

  return (
    <footer
      style={{
        background:
          "linear-gradient(135deg, var(--primary-blue) 0%, var(--dark-blue) 100%)",
        color: "white",
        padding: "60px 0 30px",
      }}
    >
      <Container>
        <Row>
          {/* Brand Section */}
          <Col lg={4} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <div
                className="navbar-logo"
                style={{
                  background:
                    "linear-gradient(135deg, var(--primary-teal) 0%, var(--accent-yellow) 100%)",
                  color: "#333",
                }}
              >
                R
              </div>
              <div>
                <h4 style={{ margin: 0, fontWeight: "700" }}>RACOHI</h4>
                <small style={{ opacity: "0.8" }}>
                  Community Health Initiative
                </small>
              </div>
            </div>
            <p
              style={{
                opacity: "0.9",
                lineHeight: "1.6",
                marginBottom: "20px",
              }}
            >
              Transforming health outcomes through integrated infectious disease
              control (HIV, TB, Malaria) and comprehensive SGBV prevention,
              creating healthier, safer communities in Rakai District.
            </p>
            <div className="d-flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  style={{
                    width: "40px",
                    height: "40px",
                    background: "rgba(255,255,255,0.1)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "rgba(255,224,102,0.2)";
                    e.target.style.transform = "translateY(-3px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.1)";
                    e.target.style.transform = "translateY(0)";
                  }}
                  title={social.platform}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={6} className="mb-4">
            <h5 style={{ marginBottom: "20px", fontWeight: "600" }}>
              Quick Links
            </h5>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {quickLinks.map((link) => (
                <li key={link.path} style={{ marginBottom: "10px" }}>
                  <Link
                    to={link.path}
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      textDecoration: "none",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.color = "var(--accent-yellow)")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.color = "rgba(255,255,255,0.8)")
                    }
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Programs */}
          <Col lg={3} md={6} className="mb-4">
            <h5 style={{ marginBottom: "20px", fontWeight: "600" }}>
              Our Programs
            </h5>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {programs.map((program, index) => (
                <li key={index} style={{ marginBottom: "10px" }}>
                  <span
                    style={{ color: "rgba(255,255,255,0.8)", fontSize: "14px" }}
                  >
                    • {program}
                  </span>
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact Info */}
          <Col lg={3} className="mb-4">
            <h5 style={{ marginBottom: "20px", fontWeight: "600" }}>
              Contact Info
            </h5>

            <div className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <span style={{ marginRight: "10px", fontSize: "1.2rem" }}>
                  📧
                </span>
                <div>
                  <small style={{ opacity: "0.8" }}>Email</small>
                  <p style={{ margin: 0, fontSize: "14px" }}>
                    rakaicommunityhealthinitiative@gmail.com
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <span style={{ marginRight: "10px", fontSize: "1.2rem" }}>
                  📱
                </span>
                <div>
                  <small style={{ opacity: "0.8" }}>Phone</small>
                  <p style={{ margin: 0, fontSize: "14px" }}>+256701816912</p>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="d-flex align-items-center">
                <span style={{ marginRight: "10px", fontSize: "1.2rem" }}>
                  📍
                </span>
                <div>
                  <small style={{ opacity: "0.8" }}>Location</small>
                  <p style={{ margin: 0, fontSize: "14px" }}>
                    Rakai District, Central Region, Uganda
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <hr
          style={{
            border: "1px solid rgba(255,255,255,0.2)",
            margin: "40px 0 20px",
          }}
        />

        <Row className="align-items-center">
          <Col md={6}>
            <p style={{ margin: 0, opacity: "0.8", fontSize: "14px" }}>
              © 2025 RACOHI. All rights reserved. | Registered Community-Based
              Organization
            </p>
          </Col>
          <Col md={6} className="text-md-end">
            <p style={{ margin: 0, opacity: "0.8", fontSize: "14px" }}>
              Built with 💙 for community empowerment
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
